import { render, staticRenderFns } from "./qPaginate.vue?vue&type=template&id=3ba07776&scoped=true&"
import script from "./qPaginate.vue?vue&type=script&lang=ts&"
export * from "./qPaginate.vue?vue&type=script&lang=ts&"
import style0 from "./qPaginate.vue?vue&type=style&index=0&id=3ba07776&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba07776",
  null
  
)

export default component.exports